import { render, staticRenderFns } from "./form-paragraph.vue?vue&type=template&id=dadcc2f0&scoped=true&"
import script from "./form-paragraph.vue?vue&type=script&lang=js&"
export * from "./form-paragraph.vue?vue&type=script&lang=js&"
import style0 from "./form-paragraph.vue?vue&type=style&index=0&id=dadcc2f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadcc2f0",
  null
  
)

component.options.__file = "form-paragraph.vue"
export default component.exports